import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Modal from "../../../components/modal/Modal";
import PasswordInput from "../../../components/input-fields/PasswordInput";
import "../css/ChangePassword.css";

const ChangePasswordModal = ({ show, onClose, onSave }) => {
    const { isChangePasswordLoading, isChangePasswordSuccess } = useSelector((state) => state.changePassword);
    const { userData } = useSelector((state) => state.auth);

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showValidation, setShowValidation] = useState(false);

    const resetForm = () => {
        setNewPassword("");
        setConfirmPassword("");
        setShowValidation(false);
    };

    // Only close the modal once the API confirms the password was changed.
    useEffect(() => {
        if (show && isChangePasswordSuccess) {
            resetForm();
            onClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isChangePasswordSuccess]);

    const handleSave = () => {
        setShowValidation(true);

        if (!newPassword.trim() || !confirmPassword.trim() || newPassword !== confirmPassword) {
            return;
        }

        onSave({ UserId: userData?.MasterUserId, Password: newPassword });
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    return (
        <Modal
            show={show}
            onClose={handleClose}
            onSave={handleSave}
            title="Change Password"
            size="modal-dialog-centered"
            loading={isChangePasswordLoading}
            className="change-password-modal"
        >
            <PasswordInput
                name="newPassword"
                label="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                placeholder="Enter new password"
                disabled={isChangePasswordLoading}
                shouldValidate={showValidation}
            />

            <PasswordInput
                name="confirmPassword"
                label="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="Re-enter new password"
                disabled={isChangePasswordLoading}
                shouldValidate={showValidation}
                validationRules={[
                    (val) => (val !== newPassword ? "New Password and Confirm Password do not match" : ""),
                ]}
            />
        </Modal>
    );
};

export default ChangePasswordModal;
